"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarSelection = void 0;
var react_1 = __importStar(require("react"));
var CarSelection_module_scss_1 = __importDefault(require("./CarSelection.module.scss"));
var SortFIlter_1 = require("../sortFilter/SortFIlter");
var Svg_1 = require("../svg/Svg");
var CarSelectionFilter_1 = require("../carSelectionFilter/CarSelectionFilter");
var useCarSelection_1 = require("../../hook/useCarSelection");
var selectors_1 = require("../../redux/selectors");
var filterSlice_1 = require("../../redux/slice/filterSlice");
var react_redux_1 = require("react-redux");
var icons_1 = require("@ant-design/icons");
var INITIAL_FILTER_VALUES = filterSlice_1.DEFAULT_FILTER_VALUES;
var CarSelection = function () {
    var isSmall = (0, react_redux_1.useSelector)(selectors_1.mediaQuerySelector).isSmall;
    var _a = (0, useCarSelection_1.useCarSelection)(), carCount = _a.carCount, filterList = _a.filterList, openFilter = _a.openFilter, isSortOpen = _a.isSortOpen, _b = _a.handlers, handleToggleFilter = _b.handleToggleFilter, handleToggleSort = _b.handleToggleSort, handleFindCars = _b.handleFindCars, handleResetFilters = _b.handleResetFilters, handleViewModeChange = _b.handleViewModeChange;
    var _c = (0, react_1.useState)(false), showMoreFilters = _c[0], setShowMoreFilters = _c[1];
    var activeFilters = (0, react_1.useMemo)(function () {
        if (!isSmall)
            return filterList; // На десктопе ВСЕ фильтры
        return showMoreFilters ? filterList : filterList.slice(0, 5); // На мобилках только 5 или все
    }, [showMoreFilters, isSmall, filterList]);
    // Динамический grid layout
    var _d = (0, react_1.useState)({
        columns: 3,
        areas: ''
    }), gridLayout = _d[0], setGridLayout = _d[1];
    (0, react_1.useEffect)(function () {
        if (isSmall) {
            // Для мобилок - одна колонка с кнопкой "еще"
            var areas = __spreadArray(__spreadArray([], activeFilters.map(function (_, index) { return "\"filter".concat(index + 1, "\""); }), true), [
                '"moreBtn"',
                '"findBtn"',
                '"resetBtn"'
            ], false).join(' ');
            setGridLayout({
                columns: 1,
                areas: areas
            });
        }
        else {
            // Для десктопа - 3 колонки БЕЗ КНОПКИ "moreBtn"
            var totalItems = activeFilters.length + 2; // фильтры + 2 кнопки (findBtn, resetBtn)
            var rows = Math.ceil(totalItems / 3);
            var areas = '';
            var allItems = __spreadArray(__spreadArray([], activeFilters.map(function (_, i) { return "filter".concat(i + 1); }), true), [
                'findBtn', 'resetBtn' // Только эти две кнопки
            ], false);
            for (var i = 0; i < rows; i++) {
                var start = i * 3;
                var end = start + 3;
                var rowItems = allItems.slice(start, end);
                // Добиваем строку точками если нужно
                while (rowItems.length < 3) {
                    rowItems.push('.');
                }
                areas += "\"".concat(rowItems.join(' '), "\" ");
            }
            setGridLayout({
                columns: 3,
                areas: areas.trim()
            });
        }
    }, [activeFilters, isSmall]);
    return (react_1.default.createElement("div", { className: CarSelection_module_scss_1.default.select },
        react_1.default.createElement("h2", { className: CarSelection_module_scss_1.default.select__title }, "\u041F\u043E\u0434\u0431\u043E\u0440 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u044F"),
        react_1.default.createElement("form", { className: CarSelection_module_scss_1.default.filter, style: {
                gridTemplateColumns: "repeat(".concat(gridLayout.columns, ", 1fr)"),
                gridTemplateAreas: gridLayout.areas
            } },
            activeFilters.map(function (filter, index) { return (react_1.default.createElement(CarSelectionFilter_1.CarSelectionFilter, { key: filter.key, dropValue: filter.values, hasVector: true, title: INITIAL_FILTER_VALUES[filter.key], filterKey: filter.key, isOpen: openFilter === filter.key, onToggle: handleToggleFilter, style: { gridArea: "filter".concat(index + 1) } })); }),
            isSmall && (react_1.default.createElement("button", { className: CarSelection_module_scss_1.default.in_stock__btn_more, onClick: function () { return setShowMoreFilters(!showMoreFilters); }, type: "button", style: { gridArea: 'moreBtn' } }, showMoreFilters ? (react_1.default.createElement(react_1.default.Fragment, null,
                "\u0421\u043A\u0440\u044B\u0442\u044C \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0444\u0438\u043B\u044C\u0442\u0440\u044B",
                ' ',
                react_1.default.createElement(icons_1.ArrowUpOutlined, { className: CarSelection_module_scss_1.default.in_stock__arrow_icon }))) : (react_1.default.createElement(react_1.default.Fragment, null,
                "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435 \u0444\u0438\u043B\u044C\u0442\u0440\u043E\u0432",
                ' ',
                react_1.default.createElement(icons_1.ArrowDownOutlined, { className: CarSelection_module_scss_1.default.in_stock__arrow_icon }))))),
            react_1.default.createElement("button", { className: CarSelection_module_scss_1.default.find_btn, type: "button", onClick: handleFindCars, style: { gridArea: 'findBtn' } }, carCount ? "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C (".concat(carCount, ")") : 'Не найдено'),
            react_1.default.createElement("button", { className: CarSelection_module_scss_1.default.reset_btn, type: "button", onClick: handleResetFilters, style: { gridArea: 'resetBtn' } }, "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u0444\u0438\u043B\u044C\u0442\u0440\u044B")),
        react_1.default.createElement("div", { className: CarSelection_module_scss_1.default.catalog_filter },
            react_1.default.createElement(SortFIlter_1.SortFilter, { isOpen: isSortOpen, onToggle: handleToggleSort }),
            !isSmall && (react_1.default.createElement("div", null,
                react_1.default.createElement(Svg_1.VerticalLayoutVector, { handler: function () { return handleViewModeChange('vertical'); } }),
                react_1.default.createElement(Svg_1.HorizontLayoutVector, { handler: function () { return handleViewModeChange('horizontal'); } }))))));
};
exports.CarSelection = CarSelection;
